import { render, staticRenderFns } from "./CardReader.vue?vue&type=template&id=8711bb30"
import script from "./CardReader.vue?vue&type=script&lang=ts"
export * from "./CardReader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports